@if (value(); as value) {
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    [class.negative]="value < 0"
  >
    @if (value < 0) {
      <use [attr.xlink:href]="SvgSpriteIcon.ArrowDownRight"></use>
    } @else {
      <use [attr.xlink:href]="SvgSpriteIcon.ArrowUpLeft"></use>
    }
  </svg>
}
